import { IconLinePlus } from "@kalodata/kds-design-icons";
import classNames from "classnames";
import { Trans } from "react-i18next";

export interface ClipUploadPlaceholderProps {
  disabled?: boolean;
  placeholderText?: React.ReactNode;
  hint?: React.ReactNode;
  uploadPlaceholder?: React.ReactNode;
}

export const ClipUploadPlaceholder = ({
  disabled,
  placeholderText,
  hint,
  uploadPlaceholder,
}: ClipUploadPlaceholderProps) => {
  if (uploadPlaceholder) return uploadPlaceholder;

  return (
    <div
      className={classNames(
        "flex h-full w-full flex-col items-center justify-center rounded-[8px] border bg-kds-bg p-[12px] transition-colors",
        disabled
          ? "cursor-not-allowed border-kds-border-subtle opacity-60"
          : "cursor-pointer border-kds-border-subtle hover:border-kds-accent",
      )}
    >
      <div className="flex flex-col items-center gap-[8px]">
        <div className="flex size-[32px] items-center justify-center rounded-full bg-kds-bg-subtle text-kds-fg">
          <IconLinePlus size={16} />
        </div>
        <span className="whitespace-nowrap text-[14px] leading-[1.4] text-kds-fg">
          {placeholderText ?? <Trans>Drag or paste</Trans>}
        </span>
        {hint ? <span className="text-center text-[12px] leading-[1.4] text-kds-fg-soft">{hint}</span> : null}
      </div>
    </div>
  );
};
